import { Formik } from 'formik';
import { Starttask } from '../Slices/timerslice';
import { getOptionsByPath } from "../utilsdata";
import { updateWorkHistoryThunk } from '../Slices/orderSlice';

import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Typography, Row, Col } from 'antd'; import { AntdButton, SelectInput } from '../blueplanitUtils/InputField';
import { REQUEST, REQUEST_TASK_TIMER} from '../Dropdownmanager';


const SaleDropdown = (props) => {
    const { open, handleClose, handleStart, SalesInfo } = props;
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

    const dispatch = useDispatch();


    const initialValues = {
 
        requestId: SalesInfo.leadID,
        clientName: '',
        processType: '',
        taskType: '',
        email: '',
        subject: '',
        body: '',
    }
 
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);



    const submit = async (values) => {

        if (!values.taskType) {
            return
        }
 
        const valuesObject = {
 
            userId: loginUser?.id.toString(),
            emailId: SalesInfo.id,
            requestId: SalesInfo.leadID.toString() || '',
            clientName: SalesInfo.clientName || '',
            processType: values.processType,
            taskType: values.taskType || 'Processing',
            email: values?.email,
            subject: values?.subject,
            body: values?.body,
            startTime: Date.now().toString(),
            endTime: "",
            department: 'Sales'
        }
        await dispatch(updateWorkHistoryThunk(valuesObject))
        const payload = {
            department: "Sales",
            task: values.taskType,
            time: Date.now(),
            requestId: SalesInfo.leadID.toString(),
        };
        localStorage.setItem('time', new Date().getTime());
        localStorage.setItem('task', values.taskType);
        localStorage.setItem('department', "Sales");
        localStorage.setItem('requestId', SalesInfo.leadID.toString());
        dispatch(Starttask(payload))
        handleStart();
        handleClose()
    }
    return (
        <>
            <Modal
                open={open}
                onCancel={handleClose}
                footer={null}
                width="50%"
                centered
            >
                <Formik
                    initialValues={initialValues}
                    onSubmit={submit}
                >
                    {({ handleChange, handleSubmit, values, errors, touched }) => (
                        <form noValidate onSubmit={handleSubmit}>
                            <Row gutter={16}>
                                <Col span={10}>
                                    <Form.Item label="Lead Id">
                                        <Typography.Text strong>{SalesInfo?.leadID}</Typography.Text>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <SelectInput
                                        label="Task"
                                        options={getOptionsByPath(NestedDatabucket, [REQUEST, REQUEST_TASK_TIMER])}
                                        value={values.taskType}
                                        onChange={(value) => handleChange({ target: { name: 'taskType', value } })}
                                        name="taskType"
                                        style={{ width: 300 }}
                                    />
                                </Col>
                            </Row>
 
                            <Row justify="end" gutter={16}>
                                <Col>
                                    <AntdButton onClick={handleClose} variant="outlined" label="Cancel" />
                                </Col>
                                <Col>
                                    <AntdButton type="primary" htmlType="submit" label="Submit" />
                                </Col>
                            </Row>
                        </form>
                    )}
                </Formik>
            </Modal>
        </>
    )
}
export default SaleDropdown;
 